import {reqBase} from '../api'
export default {
    namespaced:true,
    actions: {
        // 得到 基地信息列表
        async getBaseList({commit,state},{queryInfo}) {
            const result = await reqBase(queryInfo.currentPage,queryInfo.rowCount,queryInfo.name);
            if (result.code === 1) {
                const baseList = result.data.data;
                const baseTotal = result.data.totalCount;
                // console.log(baseList);
                commit("RECEIVE_BASE_LIST",{baseList,baseTotal});
            }
        },
    },
    mutations: {
        RECEIVE_BASE_LIST: (state,{baseList,baseTotal}) => {
            state.baseList = baseList;
            state.baseTotal = baseTotal;
        },
    },
    state: {
        baseList: [], // 基地信息数据列表
        baseTotal: 0, // 基地信息数据总条数

    },
    getters: {

    }
}



// WEBPACK FOOTER //
// ./src/store/base.js